//src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import walletReducer from './slices/walletSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    wallet: walletReducer,
  },
});